import styled, { css } from 'styled-components';
import { mediaUpTo } from 'utils/helpers/styleHelpers';
import { CustomInput } from '../CustomInput/CustomInput';
import { ReactNode } from 'react';

interface SFieldsProps {
  children?: ReactNode;
  ref?: any;
}

export const SFields = styled.div<SFieldsProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  ${mediaUpTo(
    500,
    css`
      gap: 2px;
    `
  )}
`;

interface SSmsCodeWrapperProps {
  children?: ReactNode;
  className?: string;
}

export const SSmsCodeWrapper = styled.div<SSmsCodeWrapperProps>`
  align-items: center;
  flex-direction: column;
  display: flex;
  position: relative;
`;

export const SInputNumber = styled(CustomInput)`
  max-width: 56px;
  min-width: 33px;
  padding: 0;
  text-align: center;

  ${mediaUpTo(
    500,
    css`
      border-radius: 8px !important;
    `
  )}
`;

export const SError = styled('span')`
  color: red;
  text-align: center;
  font-size: 16px;
  position: absolute;
  bottom: -48px;
  margin: 0;
`; 